const PE = {
  countryConfig: {
    accountHolderDocNumber: {
      label: "bankDetails.accountHolderDocNumber",
      placeholder: "bankDetails.RUC",
      visible: true,
      required: true,
    },
    CCI1: {
      visible: true,
      label: "bankDetails.CCI1",
      placeholder: "bankDetails.CCI1PlaceholedrPe",
      required: true,
    },
    CCI2: {
      visible: true,
      label: "bankDetails.CCI2",
      placeholder: "bankDetails.CCI2PlaceholedrPe",
      required: true,
    },
    accountNumber: {
      visible: false,
      required: false,
    },
    swift: {
      visible: true,
      required: true,
      label: "bankDetails.swift",
      placeholder: "bankDetails.swiftMinmaxValidation",
    },
    IBAN: {
      visible: false,
    },
    accountTypeBankDetails: {
      label: "bankDetails.accountTypeBankDetails",
      visible: true,
      required: true,
    },
    bankAddress: {
      visible: false,
      required: false,
    },
    bankName: {
      visible: true,
      label: "bankDetails.bankName",
      required: true,
    },
  },
};
export { PE };
